import { render, staticRenderFns } from "./ColorTranslator.vue?vue&type=template&id=97f97b26&scoped=true&"
import script from "./ColorTranslator.vue?vue&type=script&lang=js&"
export * from "./ColorTranslator.vue?vue&type=script&lang=js&"
import style0 from "./ColorTranslator.vue?vue&type=style&index=0&id=97f97b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f97b26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
installComponents(component, {VColorPicker})
